import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { ProjectConfig } from '../types';
import { ACCENT } from '../tokens';

export function ProjectCard({ project }: { project: ProjectConfig }) {
  const { t } = useTranslation('common');
  const a = ACCENT[project.hero.accent];

  return (
    <Link to={`/portfolio/${project.slug}`} className="group block h-full focus-ring rounded-2xl">
      <article className="h-full glass-card rounded-2xl border border-white/[0.02] group-hover:border-white/15 group-hover:bg-white/[0.04] transition-all duration-300 overflow-hidden flex flex-col">
        {/* Thumbnail */}
        <div className="relative aspect-[16/10] overflow-hidden bg-dark-200/50">
          <img
            src={project.thumbnail}
            alt={t(project.cardTitleKey)}
            loading="lazy"
            className="object-cover object-top w-full h-full group-hover:scale-105 transition-transform duration-700"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-dark/80 via-transparent to-transparent" />
          <span className={`absolute top-3 left-3 px-3 py-1 text-xs font-medium rounded-full glass ${a.bgSoft} ${a.text} border ${a.border}`}>
            {t(project.domainKey)}
          </span>
        </div>

        {/* Body */}
        <div className="p-6 flex flex-col flex-1">
          <div className="flex items-start justify-between gap-3 mb-2">
            <h3 className={`text-xl font-bold font-heading text-text-primary ${a.textHover} transition-colors`}>
              {t(project.cardTitleKey)}
            </h3>
            <ArrowRight className={`w-5 h-5 shrink-0 text-text-muted ${a.textHover} group-hover:translate-x-1 transition-all duration-200`} />
          </div>
          <p className="text-sm text-text-secondary leading-relaxed line-clamp-2 mb-4">{t(project.cardDescKey)}</p>
          <div className="mt-auto flex flex-wrap gap-1.5">
            {project.hero.tech.slice(0, 4).map((tech) => (
              <span key={tech} className="px-2.5 py-1 text-xs font-medium rounded-full bg-white/5 text-text-secondary border border-white/5">
                {tech}
              </span>
            ))}
          </div>
        </div>
      </article>
    </Link>
  );
}
